export const RECEIVE_GLOBAL_TOTAL = 'RECEIVE_GLOBAL_TOTAL'

export function receiveGlobalCount(total) {
  return {
    type : RECEIVE_GLOBAL_TOTAL,
    payload: total
  }
}
